import React, { useState } from 'react';
import FaqData from '../Data/faqData.json'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // FontAwesome icons


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
      <div>
        
    {/* Hero Section =================*/}
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg4.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             FAQ Grid
          </div>
        </div>
      {/* price section ================*/}
    <div className="container my-5">
      <h2 className="text-center mb-4">Frequently Asked Questions</h2>
      {FaqData.map((item, index) => (
        <div key={index} className="mb-3 border rounded p-3 bg-light w-50 " style={{marginLeft:"25%"}}>
          <div className="d-flex justify-content-between align-items-center "
            onClick={() => toggleFAQ(index)}>

            <h5 className="mb-0">{item.question}</h5>
            {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {activeIndex === index && (
            <p className="mt-2 text-start">{item.answer}</p>
          )}
        </div>
      ))}
    </div>
      </div>
  );
};

export default FAQ;
